/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Image, Mdx, ScrollTracking, Link } from '@ta-interaktiv/contentbricks'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

// TODO Set the correct article ID here
const ADDITIONAL_SHARES = 324 + 370
const ARTICLE_ID = '31092907'
const isMobile = window.innerWidth < 600

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical very segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Für wen Covid-19 gefährlich ist
              <div className='sub header'>
                Anhand von Daten aus China, Südkorea und neu auch Italien zeigen wir, ab welchem Alter es zunehmend zu Komplikationen kommt.
              </div>
            </div>
          </h1>
          <p className='ta author'>
            <strong>Marc Brupbacher und Mathias Lutz</strong>
          </p>
        </div>
      </header>

      <div
        className='ui vertical very fitted segment'
        style={{ paddingBottom: '0' }}
      >
        <div className='ui text container '>
          <Mdx file={require('text/intro.mdx')} className='cbMDX first' />
          {/* <AutofitIFrame
            aria-label='Interactive line chart'
            src='//datawrapper.dwcdn.net/fReNR/'
            height={isMobile ? '500' : '460'}
            width='581'
            style={{ paddingTop: '2em' }}
          /> */}
        </div>
      </div>
      <div className='ui vertical very fitted segment'>
        <div className='ui text container '>
          <div className='graphTitle'>
            Kaum Tote bei jungen Personen
          </div>
          <Image
            className='cbImage_inCol'
            file={[
              require('images/sterblichkeitsrate_mobile.png'),
              require('images/sterblichkeitsrate_desktop.png')
            ]}
            source='Grafik: lm/pvo Quellen: Chines Center for Disease Control and Prevention, Korea Centers for Disease Control and Prevention, Istituto Superiore di Sanità'
          />
          {/* <img
            className='deathrate'
            src={require('images/sterblichkeitsrate-01.jpg')}
            width='100%'
          /> */}
          <Mdx file={require('text/p1.mdx')} />
          <AutofitIFrame
            aria-label='Interactive line chart'
            src='//datawrapper.dwcdn.net/WpVOO/'
            height={isMobile ? '490' : '430'}
            width='581'
            style={{ paddingTop: '2em' }}
          />

          <Mdx file={require('text/p2.mdx')} />
          <AutofitIFrame
            aria-label='Interactive line chart'
            src='//datawrapper.dwcdn.net/fReNR/'
            height={isMobile ? '550' : '490'}
            width='581'
            style={{ paddingTop: '2em' }}
          />

          {/* <ScrollTracking label='content75' /> */}

          <Mdx file={require('text/p3.mdx')} />
          <AutofitIFrame
            aria-label='Interactive line chart'
            src='//datawrapper.dwcdn.net/6IXG1/'
            height={isMobile ? '490' : '370'}
            width='581'
            style={{ paddingTop: '2em' }}
          />
          <Mdx file={require('text/p4.mdx')} />
        </div>
      </div>

      <div className='ui vertical very fitted segment mainGraph '>
        <div className='ui container '>
        <div className='graphTitle'>
          So gefährlich ist das neue Coronavirus im Vergleich
          </div>
          <Image
            className='cbImage_inCol '
            file={[
              require('images/grafx_main-mobile.jpg'),
              require('images/grafx_main.jpg')
            ]}
            source='Quelle: WHO, verschiedene Studien, National Health Commission of China'
          />
        </div>
      </div>

      <div className='ui vertical very fitted segment '>
        <div className='ui text container '>
          {' '}
          <Mdx file={require('text/p5.mdx')} />
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container infographic'>
          <div
            style={{
              maxWidth: 375,
              margin: 'auto',
              borderTop: '4px solid #f7cb4a',
              background: '#fff8db',
              padding: 15
            }}
          >
            <div
              style={{
                width: '100%',
                margin: '20px 0 0 0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img
                width='70%'
                src={`//interaktiv.tagesanzeiger.ch/static/logos/${
                  parseHostname().publicationName
                }.svg`}
              />
            </div>
            <h4 className='ui small infographic header'>
              Tagespass verschenken
            </h4>
            <p>
              Hat Ihnen dieser Beitrag gefallen? Dann können Sie ihn gerne
              weiterempfehlen. Mit dem Gutscheincode <strong>24h</strong> kann
              jeder und jede für einen Tag Abo+-Inhalte lesen. Einfach unter{' '}
              <Link
                href={`https://aboshop.${parseHostname().publicationDomain}`}
              >{`aboshop.${parseHostname().publicationDomain}`}</Link>{' '}
              einlösen.
            </p>
          </div>
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        additionalShares={ADDITIONAL_SHARES}
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept, Recherche und Umsetzung',
            'Marc Brupbacher und Mathias Lutz'
          ]
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie verständlich sind die Grafiken?'
        ]}
      >
        <div
          className='ui container'
          style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
        >
          <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={[
              '29899036',
              '11435150',
              '19483314',
              '13878467',
              '13939717',
              '15650041',
              '10448437'
            ]}
          />
        </div>
      </Footer>
    </div>
  )
}
